module.exports = __webpack_public_path__ + "img/txtB.44bb470b.png";